const STATUSES = {
  created: {
    translatedName: "criado",
    color: "gray"
  },
  waiting: {
    translatedName: "aguardando pagamento",
    color: "pink"
  },
  in_analysis: {
    translatedName: "em análise",
    color: "pink"
  },
  cancelled: {
    translatedName: "cancelado",
    color: "gray"
  },
  pre_authorized: {
    translatedName: "pré-autorizado",
    color: "pink"
  },
  authorized: {
    translatedName: "autorizado",
    color: "green"
  },
  settled: {
    translatedName: "pago",
    color: "green"
  },
  refunded: {
    translatedName: "reembolsado",
    color: "gray"
  },
  reversed: {
    translatedName: "revertido",
    color: "gray"
  },
  available_for_withdrawal: {
    translatedName: "pago",
    color: "green"
  },
  requested: {
    translatedName: "requisitado",
    color: "pink"
  }
};

export default {
  filters: {
    showCreditCardNumber(cc) {
      return (
        cc.first6.substr(0, 4) +
        " " +
        cc.first6.substr(4, 6) +
        "** **** " +
        cc.last4
      );
    },

    getPaymentLabel(payload) {
      let status = STATUSES[payload];
      return status
        ? `<div class="label bg-${status.color}">${status.translatedName}</div>`
        : "";
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/paymentMixin.js